import { render } from "./HeroSearchbar.vue?vue&type=template&id=8447e286&scoped=true"
import script from "./HeroSearchbar.vue?vue&type=script&lang=js"
export * from "./HeroSearchbar.vue?vue&type=script&lang=js"

import "./HeroSearchbar.vue?vue&type=style&index=0&id=8447e286&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8447e286"]])

export default __exports__